<div class="d-flex justify-content-center align-items-center">
  <span class="icon-minus bonus-controller"
        (click)="changeCount.emit({event:$event, index:index, step:-1})">
  </span>
  <span class="count">{{value}}</span>
  <span class="icon-plus bonus-controller"
        (click)="changeCount.emit({event:$event, index:index, step:1})">
  </span>
</div>
